export const WHATSAPP_NUMBER = "593980712611";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Plaza+Quil+Guayaquil+Local+57";
export const REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Global+Pastel+Plaza+Quil+Guayaquil";
export const INSTAGRAM_URL = "https://www.instagram.com/globalpastel/?hl=es";
export const TIKTOK_URL = "https://www.tiktok.com/@global.pastel";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -90, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
